import DesktopPanel from 'pages/PlanPageDetailsOPZ/ItemPage/DesktopPanel';

import type { ComponentProps } from 'react';

import '../planRevampOrgChart.scss';

type DesktopPanelProperties = ComponentProps<typeof DesktopPanel>;

const RevampDesktopPanel = (properties: Omit<DesktopPanelProperties, 'variant'>) => (
  <DesktopPanel {...properties} variant='revamp' />
);

export default RevampDesktopPanel;
